import React from 'react'
import { Table } from 'components/Ui'

// FinancialInvoicesTab component
const FinancialInvoicesTab = ({
    finacialInvoiceData,
    finacialInvoiceTableData,
    columns,
    loading,
    dispatch,
    setFinacialInvoiceTableData,
}) => {
    return (
        <Table
            loading={loading}
            filter={false}
            datas={finacialInvoiceData}
            columns={columns}
            pagingData={finacialInvoiceTableData}
            onChange={e => dispatch(setFinacialInvoiceTableData(e))}
        />
    )
}

export default FinancialInvoicesTab
